import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { APP_CONFIG } from 'src/_config/config';

@Injectable({
  providedIn: 'root',
})
export class GetDataIntervalService {
  constructor(private datePipe: DatePipe) {}

  getDataInterval(value: any): string {
    let dataInterval;

    if (value.rangeType) {
      let endDate = new Date().setDate(new Date().getDate() - 1);
      let startDate;

      switch (value.rangeType) {
        case '30-days':
          startDate = new Date(endDate).setMonth(new Date().getMonth() - 1);
          break;
        case '7-days':
          startDate = new Date(endDate).setDate(new Date().getDate() - 7);
          break;
        case '24-hours':
          startDate = new Date(endDate).setDate(new Date().getDate() - 2);
          break;
        case '12-months':
          startDate = new Date(endDate).setFullYear(
            new Date().getFullYear() - 1
          );
          break;
        default:
          startDate = new Date();
      }

      dataInterval = {
        start: this.datePipe.transform(startDate, APP_CONFIG.dateFormat),
        end: this.datePipe.transform(endDate, APP_CONFIG.dateFormat),
      };

      return this.getTextFormat(dataInterval);
    }

    if (!value.rangeType && value.dateRange.end) {
      dataInterval = {
        start: this.datePipe.transform(
          value.dateRange.start,
          APP_CONFIG.dateFormat
        ),
        end: this.datePipe.transform(
          value.dateRange.end,
          APP_CONFIG.dateFormat
        ),
      };

      return this.getTextFormat(dataInterval);
    }

    return '-';
  }

  getTextFormat(interval: any): string {
    return `start-date=${interval.start}&end-date=${interval.end}`;
  }
}
